import React, { FC } from 'react';
import { LinkText } from '../../../../../../libs/ui-kit/common/LinkText/LinkText';
import { Badge } from 'react-bootstrap';
import { IUserAddressesListItem } from '../../service-provider/interface';

export const UserDeleteRestoreAddressModal: FC<IUserAddressesListItem> = (address) => (
  <>
    <div className="mb-3">
      <div className="text-muted font-regular-sm">Адрес</div>
      <LinkText link={address.link} text={address.value || ''} />
    </div>
    {address.label ? (
      <div className="mb-3">
        <div className="text-muted font-regular-sm">Название адреса</div>
        <div>{address.label}</div>
      </div>
    ) : null}
    <div className="mb-3">
      <div className="text-muted font-regular-sm">Удален</div>
      <Badge variant={address.isDeleted ? 'danger' : 'default'}>{address.isDeletedString}</Badge>
    </div>
  </>
);
